const _ = require('underscore');
const pubsub = require('events/pubsub');
const userContext = require('core/userContext');
// const logger = require('utilities/logger');
const urlUtilities = require('utilities/urlUtilities');
const parseHash = urlUtilities.parseHash;

const analyticsUtilities = require('utilities/analyticsUtilities');
const fireEvent = analyticsUtilities.fireEvent;
const VIEW_START = analyticsUtilities.events.VIEW_START;
const VIEW_END = analyticsUtilities.events.VIEW_END;

const whitelist = [
	{
		p: '/student-library',
		defer: 'hash'
	},
	{
		p: '/article-dashboard',
		defer: 'route'
	},
	{
		p: '/student-workspace',
		defer: 'hash'
	}
];

// Currently doesn't support hash item whitelisting
const passesWhitelist = (event, stream) => {
	return whitelist.some(item => {
		let defer = stream === item.defer || stream === 'unload' || stream === 'logout' || stream === 'modal';
		let path = event.p && event.p.indexOf(item.p) === 0;
		return defer && path;
	});
};

const navigateEventGenerator = stream => {
	return (path, oldPath) => {
		let data = path || {};
		let oldData = oldPath || {};
		let oldStream = stream;

		// logger.info('   '+stream, oldData.p, oldData.h, '->', data.p, data.h);

		if (!userContext.loggedIn()) {
			return;
		}

		if (passesWhitelist(oldData, oldStream)) {
			let oldRecord = _.assign({}, oldData, {
				h: parseHash(oldData.h)
			});
			fireEvent(VIEW_END, oldRecord);
		}

		if (passesWhitelist(data, stream)) {
			let record = _.assign({}, data, {
				h: parseHash(data.h)
			});
			fireEvent(VIEW_START, record);
		}
	};
};

pubsub.subscribe('route-changing', navigateEventGenerator('route'));
pubsub.subscribe('hash-store-update', navigateEventGenerator('hash'));

let logoutEvent = navigateEventGenerator('logout');
pubsub.subscribe('before-log-out', e =>
	logoutEvent(null, {
		p: window.location.pathname,
		h: window.location.hash
	})
);

let unloadEvent = navigateEventGenerator('unload');
window.addEventListener('beforeunload', e =>
	unloadEvent(null, {
		p: window.location.pathname,
		h: window.location.hash
	})
);

//MODAL Tracking
const fireModalEvent = (type, id) => {
	let location = window.location;
	let p = location.pathname;
	let h = parseHash(location.hash);
	let stream = 'modal';
	let data = {
		p,
		h
	};

	if (!userContext.loggedIn()) {
		return;
	}

	if (type && id && passesWhitelist(data, stream)) {
		fireEvent(type, {
			id,
			p,
			h
		});
	}
};

pubsub.subscribe('modal-opened', id => {
	fireModalEvent(VIEW_END, id);
});
pubsub.subscribe('modal-closed', id => {
	fireModalEvent(VIEW_START, id);
});

module.exports = {
	navigateEventGenerator
};
